import React from 'react';
import { BsClipboard } from 'react-icons/bs';
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

const PDFViewer = ({ url }) => {
  const notAvailable = !url || !(url !== '' || url.startsWith('data:application/pdf;base64'));

  if (notAvailable) {
    return (
      <div className='pdf-viewer-empty'>
        <BsClipboard className='pdf-viewer-empty-icon' />
        <div>No Preview available</div>
      </div>
    );
  }

  return (
    <object className='pdf-viewer-object' data={url} type='application/pdf'>
      <iframe title={`preview-${url}`} src={`https://docs.google.com/viewer?url=${url}&embedded=true`} />
    </object>
  );
};

export default PDFViewer;
